"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = exports.Group = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Text = _interopRequireDefault(require("../Typography/Text"));
var _Box = _interopRequireWildcard(require("../Containers/Box"));
var _base = require("../Icons/components/base");
var _mixins = require("../mixins");
var _excluded = ["children", "iconProps", "isOpen", "lazyLoading", "onClick", "renderRight", "title", "titleProps"],
  _excluded2 = ["children", "allowMultiple", "isControlled", "openAt", "onClick"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var groupPropTypes = {
  // Specify first item that is opened, index value. Pass in an array of indexes if allowMultiple is true
  openAt: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
  // Weather or not there can be multiple tabs opened at the same time
  allowMultiple: _propTypes["default"].bool,
  // Function to perform after section has been clicked
  onClick: _propTypes["default"].func,
  // Children passed to the component
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  // When `true` the field is controlled
  isControlled: _propTypes["default"].bool
};
var itemPropTypes = {
  // Title for the Panel header
  title: _propTypes["default"].any,
  // Specify weather the content of the accordion drawer should be rendered if it's not active
  lazyLoading: _propTypes["default"].bool
};
var Drawer = _styledComponents["default"].div.withConfig({
  displayName: "Accordion__Drawer",
  componentId: "sc-1ard3hu-0"
})(["display:block;max-height:0;transition:all 0.2s ease;", ""], function (props) {
  return props.isOpen && (0, _styledComponents.css)(["max-height:9999px;transition:all 0.2s ease;"]);
});
var Container = (0, _styledComponents["default"])(_Box["default"]).attrs(function () {
  return {
    as: "ul"
  };
}).withConfig({
  displayName: "Accordion__Container",
  componentId: "sc-1ard3hu-1"
})(["font-size:", ";", ";", ";", ";"], function (props) {
  return props.theme.fontSizes.base;
}, _mixins.listBareMixin, (0, _mixins.colorMixin)("text"), (0, _mixins.backgroundMixin)("body"));
var Title = (0, _styledComponents["default"])(_Text["default"]).withConfig({
  displayName: "Accordion__Title",
  componentId: "sc-1ard3hu-2"
})(["flex-grow:1;"]);
var Item = function Item(_ref) {
  var children = _ref.children,
    _ref$iconProps = _ref.iconProps,
    iconProps = _ref$iconProps === void 0 ? {} : _ref$iconProps,
    isOpen = _ref.isOpen,
    lazyLoading = _ref.lazyLoading,
    onClick = _ref.onClick,
    renderRight = _ref.renderRight,
    title = _ref.title,
    _ref$titleProps = _ref.titleProps,
    titleProps = _ref$titleProps === void 0 ? {} : _ref$titleProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  var HeaderIcon = isOpen ? _base.ChevronUp : _base.ChevronDown;
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], _extends({
    as: "li",
    overflow: "hidden",
    bB: true
  }, rest), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    d: _Box.displayTypes.FLEX,
    justifyContent: "space-between",
    alignItems: "center",
    gap: "s",
    pV: "s",
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(Title, _extends({
    display: "flex",
    color: "textSecondary",
    textTransform: "uppercase"
  }, titleProps), typeof title === "function" ? /*#__PURE__*/_react["default"].createElement(title) : title), renderRight === null || renderRight === void 0 ? void 0 : renderRight(), /*#__PURE__*/_react["default"].createElement(HeaderIcon, _extends({
    color: "inputIcon"
  }, iconProps))), lazyLoading && !isOpen ? null : /*#__PURE__*/_react["default"].createElement(Drawer, {
    isOpen: isOpen
  }, children));
};
exports.Item = Item;
Item.propTypes = _objectSpread(_objectSpread({}, itemPropTypes), {}, {
  /**
   * FROM PARENT: Callback for clicking on the Item - will open the item.
   *  It gets passed from parent when item is created - DO NOT pass in as a prop!
   */
  onClick: _propTypes["default"].func,
  // FROM PARENT: Current state of the item
  isOpen: _propTypes["default"].bool,
  // Content for the item
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  // A component to be rendered on the right side, near the HeaderIcon
  renderRight: _propTypes["default"].func,
  // Props that'll be passed to Title component
  titleProps: _propTypes["default"].object,
  // Props that'll be passed to HeaderIcon component
  iconProps: _propTypes["default"].object
});
var Group = function Group(_ref2) {
  var children = _ref2.children,
    allowMultiple = _ref2.allowMultiple,
    isControlled = _ref2.isControlled,
    openAt = _ref2.openAt,
    onClick = _ref2.onClick,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  var _useState = (0, _react.useState)(allowMultiple ? (0, _isArray["default"])(openAt) ? openAt : [openAt || 0] : !(0, _isArray["default"])(openAt) ? openAt : 0),
    _useState2 = _slicedToArray(_useState, 2),
    opened = _useState2[0],
    setOpened = _useState2[1];
  (0, _react.useEffect)(function () {
    if (isControlled && !!openAt) {
      setOpened(openAt);
    }
  }, [isControlled, openAt]);
  var handleClick = (0, _react.useCallback)(function (index) {
    if (!isControlled) {
      if (!allowMultiple) {
        setOpened(function (opened) {
          return opened === index ? "" : index;
        });
      } else if (opened.includes(index)) {
        setOpened(function (opened) {
          return opened.filter(function (openedIndex) {
            return openedIndex !== index;
          });
        });
      } else {
        setOpened(function (opened) {
          return [].concat(_toConsumableArray(opened), [index]);
        });
      }
    }
    onClick === null || onClick === void 0 ? void 0 : onClick(index);
  }, [allowMultiple, isControlled, opened, onClick]);
  var checkIsOpen = (0, _react.useCallback)(function (key) {
    // when the accordion is controlled,
    if (!isControlled) {
      if (!allowMultiple) {
        return opened === key;
      }
      // allow multiple, when controlled
      return opened.includes(key);
    }
    if (!allowMultiple) {
      return openAt === key;
    }

    // allow multiple & uncontrolled
    return openAt.includes(key);
  }, [isControlled, allowMultiple, openAt, opened]);
  return /*#__PURE__*/_react["default"].createElement(Container, rest, children && _react["default"].Children.map(children, function (child, index) {
    return /*#__PURE__*/_react["default"].cloneElement(child, {
      index: index,
      isOpen: checkIsOpen(index),
      onClick: function onClick(event) {
        event.preventDefault();
        handleClick(index);
      }
    });
  }));
};
exports.Group = Group;
Group.propTypes = groupPropTypes;
Group.defaultProps = {
  openAt: 0,
  allowMultiple: false,
  isControlled: false
};